import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {i18n} from '@toolify/client/src/setup/i18n'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'
import {getAiApprovalActionLabel} from '@toolify/client/src/modules/chat/functions/getAiApprovalActionLabel'
import {getLoadedLlmToolTitle} from '@toolify/client/src/modules/chat/composables/useAvailableLlmTools'

const {t} = i18n.global

export class AiApprovalRequestedNotificationStrategy extends DefaultNotificationStrategy<NotificationType.AiApprovalRequested> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.AiApprovalRequested>, authorNick: string): IBrowserNotification {
    return {
      sound: getNotificationSoundUrl('new-notification.wav'),
      title: t('notifications.browserNotifications.aiApprovalRequested', {author: authorNick}),
      body: t('notifications.browserNotifications.aiApprovalRequestedBody', {action: getAiApprovalActionLabel(notification.payload, getLoadedLlmToolTitle)}),
    }
  }
}
